import React from 'react';
import ReactDOM from 'react-dom';
import Product from './pages/product';

ReactDOM.render(
  <React.StrictMode>
    <Product />
  </React.StrictMode>,
  document.getElementById('root')
);